import { FC } from 'react';

export const KeyboardArrowDown: FC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
  </svg>
);

export default KeyboardArrowDown;
